import dayjs from 'dayjs';

export function getTimer(fixture: any): string {
  if (!fixture?.matchDate) return 'N/A';

  const matchDateTime = new Date(fixture.matchDate);

  // ✅ Handle invalid date
  if (Number.isNaN(matchDateTime.getTime())) {
    return 'N/A';
  }

  const now = Date.now();
  const matchTime = matchDateTime.getTime();
  const timeDifference = matchTime - now;

  // ✅ Future match
  if (timeDifference > 0) {
    const minutes = Math.floor((timeDifference / (1000 * 60)) % 60);
    const hours = Math.floor((timeDifference / (1000 * 60 * 60)) % 24);
    const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));

    const d = days > 0 ? `${days} day${days > 1 ? 's' : ''}, ` : '';
    const h = hours > 0 ? `${hours} hr${hours > 1 ? 's' : ''}, ` : '';
    const m = minutes > 0 ? `${minutes} min${minutes > 1 ? 's' : ''}` : '';

    return `In ${d}${h}${m}`.trim();
  }

  // ✅ Past / Live logic
  if (timeDifference + 10800000 < 0) {
    // Match finished → show time
    return dayjs(matchDateTime).format('hh:mm A');
  }

  return 'Live';
}